<ng-container [formGroup]="newEditForm">
    <td>{{ designacionAlmacen ? designacionAlmacen.almacenId : '' }}</td>
    <td class="string" *ngIf="!designacionAlmacen" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="almacenesList" [selectedItem]="newEditForm.get('desAlmacen')" [disabled]="disabledAlmacenes" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="string" *ngIf="designacionAlmacen" [ngClass]="{'show-error': showError}">
      <app-filterable-list [itemsList]="designacionesAlmacen" [selectedItem]="newEditForm.get('desAlmacen')" [disabled]="disabledAlmacenes" [placeHolder]="false"></app-filterable-list>
  </td>
    <td class="actions">
        <ng-container *ngIf="editable">
          <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
          <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
          <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('DSG_ALM_Del')" title="{{'titles.eliminar' | translate}}"
              app-click-stop-propagation (click)="askDelete(designacionAlmacen)"
              title="{{'titles.eliminar' | translate}}"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{'global.eliminar.descripcion' | translate}}</h4>
      </header>
      <content>
        <p>{{'global.eliminar.confirmacion' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>
